var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-chip',[_vm._v("dsfsd")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }